/**
 */
const singaporeConfig = {
	heroSectionContent: {
		offerDisclaimer: 'Then just $17.99/mo. until canceled',
		offerBadgeImgSrc: '/assets-mkt/routes/home/gradient_da_badge_v3_singapore.svg',
		offerBadgeImgAltTxt:
			'Click to Learn about our Special Annual Offer. Get up to 70% off our monthly pricing! $60.99 per year until canceled'
	},
	prospectRegisterContent: {
		disclaimer: 'Then $17.99/mo. until canceled'
	}
};

export default singaporeConfig;
